import { useState, memo } from 'react';
import { Portal } from 'models';

import { ButtonShape } from 'components';

import { useStyles } from './style';
import clsx from 'clsx';

interface Props {
  portals: Portal[];
  handleSelectPortal: (portal: Portal) => void;
  handleExit: () => void;
}

const StartPortalPicker: React.FC<Props> = ({
  portals,
  handleSelectPortal,
  handleExit,
}) => {
  const classes = useStyles();
  const [selectedPortal, setSelectedPortal] = useState<Portal | null>(null);

  const handleClickRow = (portal: Portal) => {
    setSelectedPortal(portal);
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.h2}>Valitse palvelu</h2>
      <ul className={classes.block}>
        {portals.map((portal) => {
          return (
            <li
              key={portal.Id}
              onClick={() => handleClickRow(portal)}
              className={clsx(classes.row, {
                [classes.activeRow]: selectedPortal?.Id === portal.Id,
              })}
            >
              <span className={classes.label}>{portal.Label}</span>
            </li>
          );
        })}
      </ul>
      <div className={classes.buttonsWrapper}>
        <ButtonShape
          className={classes.button}
          onClick={
            selectedPortal
              ? () => handleSelectPortal(selectedPortal)
              : undefined
          }
        >
          OK
        </ButtonShape>
        <ButtonShape className={classes.button} onClick={handleExit}>
          Kirjaudu ulos
        </ButtonShape>
      </div>
    </div>
  );
};

export default memo(StartPortalPicker);
